const phonePattern =
  /^(?:\+?86)?1[3-9]\d{9}$|^(?:\+?84|0)(?:3|5|7|8|9)\d{8}$/;

export type VerificationScene = 'REGISTER' | 'LOGIN' | 'RESET_PASSWORD' | 'BINDING';

function normalizeEmail(value: string) {
  const text = value.trim().toLowerCase();
  const at = text.lastIndexOf('@');
  if (at <= 0 || at === text.length - 1) return text;
  const local = text.slice(0, at);
  const domain = text.slice(at + 1);
  try {
    return `${local}@${new URL(`http://${domain}`).hostname}`;
  } catch {
    return text;
  }
}

export function normalizeIdentity(raw: string) {
  const text = raw.trim();
  if (text.includes('@')) return normalizeEmail(text);
  return text.replace(/[\s-]/g, '');
}

export function resolveAccount(account: string): { phone: string } | { email: string } | null {
  const text = account.trim();
  if (!text || text.length > 320) return null;
  if (text.includes('@')) {
    const email = normalizeEmail(text);
    if (email.length > 320 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return null;
    return { email };
  }
  const phone = text.replace(/[\s-]/g, '');
  if (!phonePattern.test(phone)) return null;
  return { phone };
}
